import { render, staticRenderFns } from "./TranslationBillingView.vue?vue&type=template&id=630637a8"
import script from "./TranslationBillingView.vue?vue&type=script&lang=js"
export * from "./TranslationBillingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports